import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { CommonCieModel } from 'src/app/model/common/cie';
import { ReportCieCertificateModel } from 'src/app/model/report/cie-certificate';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CieService extends BaseService {
  constructor(
    protected store: Store<any>,
    protected rest: RestService,
    protected sanitizer: DomSanitizer
  ) {
    super();
  }

  fillCieSuggestionBy = (query: string): Observable<CommonCieModel[]> =>
    this.rest.get<CommonCieModel[]>({
      url: `${environment.endpoints.common}/cie`,
      params: { query },
    });

  generateCertificate = (
    certificateInformation: ReportCieCertificateModel
  ): Observable<SafeResourceUrl> =>
    this.rest
      .post<BlobPart, ReportCieCertificateModel>({
        url: `${environment.endpoints.report}/cie-certificate`,
        body: certificateInformation,
        header: {
          responseType: 'BLOB' as 'json',
        },
      })
      .pipe(map(this.rest.mapResponseAsPdf), share());
}
